const theme = {
  color: {
    white: "#FFFFFF",
    black: "#000000",
    lightGray: "#F9F9F9",
    gray: "#F0F0F0",
    darkGray: "#D8D8D8",
    lightBlack: "#888888",
    wineRed: "#921628",
  },
  radius: {
    small: "5px",
    medium: "10px",
  },
  fontSize: {
    tiny: "10px",
    small: "12px",
    normal: "16px",
    default: "18px",
    inbetween: "20px",
    medium: "24px",
    large: "32px",
    huge: "40px",
  },
  font: {
    mono: "Courier New, Courier, monospace",
  },
  space: {
    nano: "4px",
    tiny: "8px",
    small: "16px",
    medium: "24px",
    large: "32px",
    huge: "40px",
    giant: "60px",
  },
};

export default theme;
